import { Radio } from 'antd';
import styled from 'styled-components';

const BaseRadioGroup = Radio.Group;

export const RadioGroup = styled(BaseRadioGroup)`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  input {
    height: initial !important;
  }
`;
